import React from "react";

interface InputHelpTextProps
{
    text: string
    id: string
}

export const InputHelpText = ( {text, id}: InputHelpTextProps ) => {
    return (
        <small id={id} className="form-text text-muted">
            {text}
        </small>
    )
}
